export default Object.freeze({
  LOADING: 'LOADING',
  EMPTY: 'EMPTY',
  MATCHING: 'MATCHING',
  MATCHED: 'MATCHED',
})
